import numeral from 'numeral'

import { LANGUAGE } from '@/domains/CommonDomain'

import { toInteger } from './numberUtils'

const { ordinal: commonOrdinal, abbreviations: commonAbbreviations } = numeral.localeData('en')

export function getRupiahFormat(data: number | string, givenFormat: string = '$0,0') {
  const amount = typeof data === 'string' ? toInteger(data) : data

  return numeral(amount).format(givenFormat)
}

/* 화폐 단위 없이 formatted 금액 반환 (10000 -> 10.000) */
export function getRupiahFormatWithoutUnit(data: number | string) {
  const amount = typeof data === 'string' ? toInteger(data) : data

  return numeral(amount).format()
}

export const init = (currentLanguage: string) => {
  numeral.register('locale', LANGUAGE.KO, {
    delimiters: {
      thousands: '.',
      decimal: '.',
    },
    abbreviations: commonAbbreviations,
    ordinal: commonOrdinal,
    currency: {
      symbol: 'Rp ',
    },
  })

  numeral.register('locale', LANGUAGE.IN, {
    delimiters: {
      thousands: '.',
      decimal: ',',
    },
    abbreviations: commonAbbreviations,
    ordinal: commonOrdinal,
    currency: {
      symbol: 'Rp ',
    },
  })

  numeral.register('locale', LANGUAGE.EN, {
    delimiters: {
      thousands: ',',
      decimal: '.',
    },
    abbreviations: commonAbbreviations,
    ordinal: commonOrdinal,
    currency: {
      symbol: 'IDR ',
    },
  })

  numeral.locale(currentLanguage)
}
